<template>
	<el-dialog :title="title" :visible.sync="dialogFormVisible" :close-on-click-modal="false" append-to-body>
		<el-form :model="form" :rules="rules" ref="form">
			<el-form-item label="服务器名称" :label-width="formLabelWidth" prop="name">
				<el-input size="medium" v-model="form.name" autocomplete="off" placeholder="服务器名称"></el-input></el-form-item>
			<el-form-item label="CTI地址" :label-width="formLabelWidth" prop="ctiserver"><el-input size="medium" v-model="form.ctiserver" autocomplete="off" placeholder="CTI地址"></el-input></el-form-item>
			<el-form-item label="SPI地址" :label-width="formLabelWidth" prop="sipserver"><el-input size="medium" v-model="form.sipserver" autocomplete="off" placeholder="SPI地址"></el-input></el-form-item>
			<el-form-item label="企业标识号" :label-width="formLabelWidth" prop="companyCode"><el-input size="medium" v-model="form.companyCode" autocomplete="off" placeholder="企业标识号"></el-input></el-form-item>
			<el-form-item label="API地址" :label-width="formLabelWidth" prop="apiserver"><el-input size="medium" v-model="form.apiserver" autocomplete="off" placeholder="API地址"></el-input></el-form-item>
			<el-form-item label="Token地址" :label-width="formLabelWidth" prop="apitoken"><el-input size="medium" v-model="form.apitoken" autocomplete="off" placeholder="Token地址"></el-input></el-form-item>
			<el-form-item label="客户标识号" :label-width="formLabelWidth" prop="clientCode"><el-input size="medium" v-model="form.clientCode" autocomplete="off" placeholder="客户标识号"></el-input></el-form-item>

			<el-form-item label="拨号类型" :label-width="formLabelWidth" prop="dialType">
				<el-select size="medium" v-model="form.dialType" placeholder="请选择活动区域" @change="selectSet">
					<el-option label="请选择" value=" "></el-option>
					<el-option label="九五" :value="1"></el-option>
					<el-option label="华旗" :value="2"></el-option>
					<el-option label="测试" :value="3"></el-option>
				</el-select>
			</el-form-item>

			<el-form-item :label="point1Title" :label-width="formLabelWidth" v-if="form.dialType==2">
				<el-col :span="10">
					<el-form-item  prop="point1">
						<el-input size="medium" v-model="form.point1" autocomplete="off" placeholder="端口号一"></el-input>
					</el-form-item>
				</el-col>
				<!-- <el-col class="line" :span="4" style="text-align: right;">{{point2Title}}</el-col>
				<el-col :span="10">
					<el-form-item prop="端口号二"><el-input v-model="form.point2" autocomplete="off" placeholder="端口号二"></el-input></el-form-item>
				</el-col> -->
			</el-form-item>
			<el-form-item :label="def1Title1" :label-width="formLabelWidth" v-if="form.dialType==2" prop="def1"><el-input size="medium" v-model="form.def1" autocomplete="off" placeholder="自定义一"></el-input></el-form-item>
			<el-form-item :label="def1Title2" :label-width="formLabelWidth" v-if="form.dialType==2" prop="def2"><el-input size="medium" v-model="form.def2" autocomplete="off" placeholder="自定义二"></el-input></el-form-item>
			<el-form-item :label="def1Title3" :label-width="formLabelWidth" v-if="form.dialType==2" prop="def3"><el-input size="medium" v-model="form.def3" autocomplete="off" placeholder="自定义三"></el-input></el-form-item>
			<!-- <el-form-item :label="def1Title4" :label-width="formLabelWidth" v-if="form.dialType==2"><el-input v-model="form.def4" autocomplete="off" placeholder="自定义四"></el-input></el-form-item> -->
			<!-- <el-form-item :label="def1Title5" :label-width="formLabelWidth" v-if="form.dialType==2"><el-input v-model="form.def5" autocomplete="off" placeholder="自定义五"></el-input></el-form-item> -->
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button size="medium" @click="resetForm('form')">取 消</el-button>
			<el-button v-loading="loading" size="medium" type="primary" @click="setDetails('form')">确 定</el-button>
		</div>
	</el-dialog>
</template>

<script>
export default {
	data() {
		return {
			point1Title:'端口号一',
			point2Title:'端口号二',
			def1Title1:'自定义一',
			def1Title2:'自定义二',
			def1Title3:'自定义三',
			def1Title4:'自定义四',
			def1Title5:'自定义五',
			title: '添加服务器',
			dialogFormVisible: false,
			dialogFormVisibleType: 1, //添加编辑类型
			form: {
				name: '',
				ctiserver: '',
				sipserver: '',
				companyCode: '',
				apiserver: '',
				apitoken: '',
				clientCode: '',
				dialType: '',
				point1: '',
				def1: '',
				def2: '',
				def3: '',
			},
			formLabelWidth: '100px',
			rules: {
				name: [
					{ required: true, message: '服务器名称不能为空！', trigger: 'blur, change' },
				],
				ctiserver: [
					{ required: true, message: 'CTI地址不能为空！', trigger: 'blur, change' }
				],
				sipserver: [
					{ required: false }
				],
				companyCode: [
					{ required: false }
				],
				apiserver: [
					{ required: true, message: 'API地址不能为空！', trigger: 'blur, change' }
				],
				apitoken: [
					{ required: false }
				],
				clientCode: [
					{ required: false }
				],
				dialType: [
					{ required: false }
				],
				point1: [
					{ required: false }
				],
				def1: [
					{ required: false }
				],
				def2: [
					{ required: false }
				],
				def3: [
					{ required: false }
				],
			},
			loading: false
		};
	},
	methods: {
		selectSet(value){
			console.log(value)
			if(value==2){
				this.point1Title='sip端口'
				this.point2Title='端口号二'
				this.def1Title1='sip密码'
				this.def1Title2='录音播放地址 '
				this.def1Title3='录音替换前缀（如C:\\）'
				this.def1Title4='自定义四'
				this.def1Title5='自定义五'
			}else{
				this.point1Title='端口号一'
				this.point2Title='端口号二'
				this.def1Title1='自定义一'
				this.def1Title2='自定义二'
				this.def1Title3='自定义三'
				this.def1Title4='自定义四'
				this.def1Title5='自定义五'
			}
		},
		resetForm(formName) {
			this.dialogFormVisible = false;
			this.$refs[formName].resetFields();
		},
		setDetails(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					this.loading = true
					let that = this;
					let data = that.form;
					let params = {
						that: this,
						url: `${this.$config.service.serverUpdate}`,
						method: 'POST',
						data: data,
						cb(res) {
							if (res.code == 0) {
								that.$emit('serverOk');
								that.resetForm(formName)
								that.$message.success(res.message);
							} else {
								that.$message.error(res.message);
							}
						},
						finally() {
							that.loading = false
						}
					};
					this.$util.request(params);
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		addDetails() {
			this.title = '添加服务器';
			this.dialogFormVisibleType = 1;
			this.form = {
				id: 0
			};
			this.dialogFormVisible = true;
		},
		editDetails() {
			this.title = '修改服务器';
			this.selectSet(this.form.dialType)
			this.dialogFormVisibleType = 2;
			this.dialogFormVisible = true;
		}
	}
};
</script>

<style></style>
